// import { Injectable, Inject } from '@angular/core';
// // import { AngularFireDatabase } from 'angularfire2/database';
// import { AngularFireDatabase } from 'angularfire2/database';
// import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/observable/from';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/mergeMap';
// import 'rxjs/add/operator/toArray';
// import 'rxjs/add/operator/first';
// import 'rxjs/add/operator/shareReplay';

// interface YearItem {
//   key?: string;
//   link?: string;
//   num_page?: number;
// }

// @Injectable()
// export class PublicationsService {
//   private pageNumberCache: { [key: string]: Observable<number> } = {};

//   constructor(private db: AngularFireDatabase) { }

//   findPublicationsForHome(arg): Observable<any[]> {
//     return this.db.list('publications', ref => ref.orderByChild('type').equalTo('international').limitToLast(5))
//       .valueChanges()
//       .first()
//       .map(array => array.reverse())
//   }

//   findArgPublications(arg): Observable<any[]> {
//     return this.db.list('publications', ref => ref.orderByChild('type').equalTo(arg))
//       .valueChanges()
//       .map(arr => {
//         const groupedByYear = arr.reduce((acc, curr) => {
//           const year = curr['year'];
//           if (!acc[year]) {
//             acc[year] = [];
//           }
//           acc[year].push(curr);
//           return acc;
//         }, {});

//         return Object.keys(groupedByYear)
//           .map(year => groupedByYear[year].sort(compare))
//           .reverse();
//       });
//   }

//   findPublicationById(id): Observable<any[]> {
//     return this.db.list('publications', ref => ref.orderByChild('id').equalTo(id))
//       .valueChanges()
//       .first()
//   }

//   // 06/18/24 added
//   findPublicationsByTypeAndPage(type: string, page: number): Observable<any[]> {
//     const typePage = `${type}_${page}`;
//     return this.db.list('publications', ref =>
//       ref.orderByChild('type_page').equalTo(typePage)
//     ).valueChanges()
//     .mergeMap(arr => Observable.from(arr)
//       .groupBy( event => event['year'] )
//       .mergeMap(group => group.toArray()).map(arr => arr.sort(compare))
//       .toArray()
//       .map(arr => arr.reverse())
//     )
//   }

//   // 06/18/24 added
//   getPublicationPagesByType(type:string):Observable<number> {
//     return this.db.list('years', ref => ref.orderByChild('link').equalTo(type))
//     .snapshotChanges()
//     .pipe(
//       map(changes => {
//         const item = changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))[0];
//         return item ? item.num_page : 0;
//       })
//     );
//   }


//   findPageNumberByTypeAndYear(type: string, year: string): Observable<number> {
//     const cacheKey = `${type}_${year}`;

//     if (this.pageNumberCache[cacheKey]) {
//       return this.pageNumberCache[cacheKey];
//     }

//     const query = this.db.list('publications', ref =>
//       ref.orderByChild('type_year').equalTo(cacheKey).limitToLast(1)
//     )
//     .snapshotChanges()
//     .pipe(
//       map(changes => {
//         const item = changes.map(c => ({ key: c.payload.key, ...(c.payload.val() as any) }))[0];
//         return item ? item.page : 1;
//       }),
//       shareReplay(1)
//     );

//     this.pageNumberCache[cacheKey] = query;
//     return query;
//   }
// }

// function compare(a, b) {
//   let idA = a.id;
//   let idB = b.id;
//   let comparison = 0;

//   if (idA > idB) {
//     comparison = -1;
//   } else if (idA < idB) {
//     comparison = 1;
//   }

//   return comparison;
// }


import { Injectable, Inject } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/from';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/toArray';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/shareReplay';

interface YearItem {
  key?: string;
  link?: string;
  num_page?: number;
}

@Injectable()
export class PublicationsService {
  private pageNumberCache: { [key: string]: Observable<number> } = {};

  constructor(private db: AngularFireDatabase) {}

  /**
   * 최신 5개의 국제 논문 가져오기
   */
  findPublicationsForHome(arg): Observable<any[]> {
    return this.db.list('publications', ref => 
      ref.orderByChild('type').equalTo('international').limitToLast(5))
      .valueChanges()
      .first()
      .map(array => array.reverse());
  }

  /**
   * 특정 타입의 논문 가져오기
   */
  findArgPublications(arg): Observable<any[]> {
    return this.db.list('publications', ref => ref.orderByChild('type').equalTo(arg))
      .valueChanges()
      .map(arr => {
        const groupedByYear = arr.reduce((acc, curr) => {
          const year = curr['year'];
          if (!acc[year]) acc[year] = [];
          acc[year].push(curr);
          return acc;
        }, {});

        return Object.keys(groupedByYear)
          .map(year => groupedByYear[year].sort(compare))
          .reverse();
      });
  }

  /**
   * 특정 ID의 논문 찾기
   */
  findPublicationById(id): Observable<any[]> {
    return this.db.list('publications', ref => ref.orderByChild('id').equalTo(id))
      .valueChanges()
      .first();
  }

  /**
   * 페이지 번호에 따라 특정 타입의 논문 가져오기
   */
  findPublicationsByTypeAndPage(type: string, page: number): Observable<any[]> {
    const typePage = `${type}_${page}`;
    return this.db.list('publications', ref =>
      ref.orderByChild('type_page').equalTo(typePage))
      .valueChanges()
      .mergeMap(arr => Observable.from(arr)
        .groupBy(event => event['year'])
        .mergeMap(group => group.toArray())
        .map(arr => arr.sort(compare))
        .toArray()
        .map(arr => arr.reverse())
      );
  }

  /**
   * 특정 타입의 전체 페이지 개수 가져오기
   */
  getPublicationPagesByType(type: string): Observable<number> {
    return this.db.list('years', ref => ref.orderByChild('link').equalTo(type))
      .snapshotChanges()
      .map(changes => {
        const items: YearItem[] = changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        const item = items.length > 0 ? items[0] : null;
        return item && item.num_page !== undefined ? item.num_page : 0;
      });
  }

  /**
   * 특정 타입과 연도의 페이지 번호 찾기
   */
  findPageNumberByTypeAndYear(type: string, year: string): Observable<number> {
    const cacheKey = `${type}_${year}`;

    if (this.pageNumberCache[cacheKey]) {
      return this.pageNumberCache[cacheKey];
    }

    const query = this.db.list('publications', ref =>
      ref.orderByChild('type_year').equalTo(cacheKey).limitToLast(1))
      .snapshotChanges()
      .map(changes => {
        const item = changes.map(c => ({ key: c.payload.key, ...(c.payload.val() as any) }))[0];
        return item ? item.page : 1;
      })
      .shareReplay(1);

    this.pageNumberCache[cacheKey] = query;
    return query;
  }
}

/**
 * 비교 함수: ID 기준으로 내림차순 정렬
 */
function compare(a, b) {
  let idA = a.id;
  let idB = b.id;
  let comparison = 0;

  if (idA > idB) {
    comparison = -1;
  } else if (idA < idB) {
    comparison = 1;
  }

  return comparison;
}



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/services/publications.service.ts